<span class="float-end text-secondary fw-normal">{{ controlName?.value?.length || 0 }}/{{ limit }}</span>
